import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  swapButton: {
    color: theme.colors.action_text,
    width: 250
  },
  swapButtonDisabled: {
    color: theme.colorPalette.orange_75,
    ...reskinStyles(theme, { color: theme.colors.action_text }),
    opacity: '50%'
  },
  swapIcon: {
    marginLeft: 10
  },
  swapTooltip: {
    width: 50,
    marginLeft: 15,
    top: -10,
    position: 'relative'
  }
}));

export default useStyles;
